import ME from './me.gql';
import SEND_SIGNATURE from './sendSignature.gql';

export { ME, SEND_SIGNATURE };
